import React from 'react'
import BackToGameList from '../../utils/BackToGameList'
    import { useLocation } from "react-router-dom";

function ExternalGames(props) {
    const height = window.innerHeight - 150
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();
    const game_url = query.get("game_url")
    console.log("game_url", game_url)
  return (
    <>
        <BackToGameList />
        <iframe width={'100%'} height={height} src={game_url}>ExternalGames</iframe>
    </>
  )
}

export default ExternalGames